import React from 'react';

// Cœur - Outline simple et élégant comme l'image originale
export const HeartSvg = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="3.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M50 88 C15 55 8 40 12 28 C17 12 35 8 50 22 C65 8 83 12 88 28 C92 40 85 55 50 88 Z" />
  </svg>
);

// Fer à cheval - Outline avec 5 rivets/trous espacés (comme l'image originale)
export const HorseshoeSvg = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Forme du fer à cheval en outline */}
    <path d="M18 85 C8 85 5 72 5 55 C5 28 25 8 50 8 C75 8 95 28 95 55 C95 72 92 85 82 85 L75 85 C70 85 68 78 68 72 L68 55 C68 42 60 32 50 32 C40 32 32 42 32 55 L32 72 C32 78 30 85 25 85 Z" />
    {/* 5 trous/rivets comme points */}
    <circle cx="18" cy="55" r="4" fill="currentColor" />
    <circle cx="32" cy="22" r="4" fill="currentColor" />
    <circle cx="50" cy="14" r="4" fill="currentColor" />
    <circle cx="68" cy="22" r="4" fill="currentColor" />
    <circle cx="82" cy="55" r="4" fill="currentColor" />
  </svg>
);

// Trèfle 4 feuilles - Outline fin avec 4 pétales en forme de cœur et tige
export const CloverSvg = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Pétale haut gauche */}
    <path d="M50 50 C45 45 35 45 32 38 C28 28 35 18 45 20 C50 21 50 28 50 35" />
    <path d="M50 35 C50 28 50 21 55 20 C65 18 72 28 68 38 C65 45 55 45 50 50" />
    {/* Pétale bas gauche */}
    <path d="M50 50 C45 55 35 55 32 62 C28 72 35 82 45 80 C50 79 50 72 50 65" />
    {/* Pétale bas droit */}
    <path d="M50 65 C50 72 50 79 55 80 C65 82 72 72 68 62 C65 55 55 55 50 50" />
    {/* Feuilles simplifiées */}
    <ellipse cx="38" cy="32" rx="10" ry="14" />
    <ellipse cx="62" cy="32" rx="10" ry="14" />
    <ellipse cx="38" cy="68" rx="10" ry="14" />
    <ellipse cx="62" cy="68" rx="10" ry="14" />
    {/* Tige */}
    <path d="M50 78 L50 98" strokeWidth="3" />
  </svg>
);

// Étoile 5 branches - Outline simple et propre
export const StarSvg = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="3.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="50,8 61,38 93,38 67,58 78,90 50,70 22,90 33,58 7,38 39,38" />
  </svg>
);

// Couronne - Remplie avec 3 pointes principales et 3 orbes
export const CrownSvg = ({ size = 24, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
    fill="currentColor"
  >
    {/* Corps de la couronne avec pointes */}
    <path d="M8 70 L8 42 L32 55 L50 30 L68 55 L92 42 L92 70 Z" />
    {/* Bande inférieure */}
    <rect x="8" y="70" width="84" height="12" rx="1" />
    {/* 3 Orbes sur les pointes */}
    <circle cx="8" cy="38" r="7" />
    <circle cx="50" cy="22" r="7" />
    <circle cx="92" cy="38" r="7" />
  </svg>
);

export const symbols = [
  { id: 'none', name: 'Aucun', component: null },
  { id: 'heart', name: 'Cœur', component: HeartSvg },
  { id: 'horseshoe', name: 'Fer à cheval', component: HorseshoeSvg },
  { id: 'clover', name: 'Trèfle', component: CloverSvg },
  { id: 'star', name: 'Étoile', component: StarSvg },
  { id: 'crown', name: 'Couronne', component: CrownSvg },
];

export default symbols;
